// 来米配置
const wx = {
	// 商户id
	mch_id: "",
	// 服务id
	service_id: "",
	// 消息密钥 v2
	api_key: "",
	// 是否启用支付分用户确认模式
	need_user_confirm: true,
};

const alipay = {
	// appid
	app_id: "",
	// 请求使用的编码格式，如utf-8,gbk,gb2312等
	charset: "utf-8",
	// 应用私钥
	privateKey: "",
};
 
export default {
	// domain: "https://ht.wteam.club/bpp", // 安徽客户的
	// domain: "https://admin2.51sioc.com/api",  // 河南的
	// domain: "https://ht.wteam.club/api",  // 我们的 
	// domain: "http://localhost:8200/api",  // 本地
	// domain: "https://cwshop.tmmbuy.com/api",  // 淘喵喵 
	domain: "https://cwshop.scxssss.com/api",  // 满高朋     
	wx: wx,
	alipay: alipay,
}


// WEBPACK FOOTER //
// ./src/common/appconf.js